import {useState} from "react";
import SchedulerMobileJobList from "./SchedulerMobileJobList";
import SchedulerMobileTabs, {
    SCHEDULER_MOBILE_BACKLOG_VIEW,
} from "./SchedulerMobileTabs";
import SchedulerWorkerTagCloud from "./SchedulerWorkerTagCloud";

export default function SchedulerMobileView({
    activeWorkerId,
    backlogCount,
    backlogCards,
    backlogHeader,
    backlogEmptyMessage,
    fieldWorkerArray,
    onActiveWorkerChange,
    onOpenWorkerMap,
    onClearFilter,
    showWorkerLocation,
    todayWorkerIds,
    workerCount,
    workerCards,
    workerEmptyMessage,
    workerWorkloadCounts,
}) {
    const [activeView, setActiveView] = useState(SCHEDULER_MOBILE_BACKLOG_VIEW);

    return (
        <div className="scheduler-mobile-view">
            <SchedulerMobileTabs
                activeView={activeView}
                backlogCount={backlogCount}
                onChange={setActiveView}
                workerCount={workerCount}
            />
            {activeView === SCHEDULER_MOBILE_BACKLOG_VIEW ? (
                <section
                    className="scheduler-mobile-panel"
                    role="tabpanel"
                    aria-label="Backlog jobs"
                >
                    {backlogHeader ? (
                        <div className="scheduler-mobile-panel-header">{backlogHeader}</div>
                    ) : null}
                    <SchedulerMobileJobList
                        emptyMessage={backlogEmptyMessage}
                        hasJobs={backlogCount > 0}
                        onClearFilter={onClearFilter}
                    >
                        {backlogCards}
                    </SchedulerMobileJobList>
                </section>
            ) : (
                <section
                    className="scheduler-mobile-panel"
                    role="tabpanel"
                    aria-label="Worker jobs"
                >
                    <div className="scheduler-mobile-worker-selector">
                        <div className="scheduler-mobile-worker-selector-label">Select worker</div>
                        <SchedulerWorkerTagCloud
                            activeWorkerId={activeWorkerId}
                            ariaLabel="Workers to view"
                            fieldWorkerArray={fieldWorkerArray}
                            onChange={onActiveWorkerChange}
                            onOpenWorkerMap={onOpenWorkerMap}
                            showWorkerLocation={showWorkerLocation}
                            todayWorkerIds={todayWorkerIds}
                            workerWorkloadCounts={workerWorkloadCounts}
                        />
                    </div>
                    <SchedulerMobileJobList
                        emptyMessage={workerEmptyMessage}
                        hasJobs={workerCount > 0}
                        onClearFilter={onClearFilter}
                        showClearFilter={false}
                    >
                        {workerCards}
                    </SchedulerMobileJobList>
                </section>
            )}
        </div>
    );
}
